import { render, staticRenderFns } from "./OriginalTeethOpacity.vue?vue&type=template&id=03949485&scoped=true&"
import script from "./OriginalTeethOpacity.vue?vue&type=script&lang=js&"
export * from "./OriginalTeethOpacity.vue?vue&type=script&lang=js&"
import style0 from "./OriginalTeethOpacity.vue?vue&type=style&index=0&id=03949485&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03949485",
  null
  
)

export default component.exports